module.exports = __webpack_public_path__ + "img/swap-line.947475f8.svg";